import EnableInConfig from './EnableInConfig'

export default EnableInConfig
